/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const SplitScreenIcon = /*#__PURE__*/ createSvgIcon(
  'SplitScreenIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.44 15.56c.294.293.647.44 1.06.44h13a1.45 1.45 0 001.06-.438c.293-.291.44-.643.44-1.056V5.5c0-.413-.147-.766-.44-1.06A1.444 1.444 0 0016.5 4h-13a1.45 1.45 0 00-1.06.438C2.148 4.729 2 5.08 2 5.494V14.5c0 .413.147.766.44 1.06zM12 14.5H3.5v-9H12v9zm1.5 0h3v-9h-3v9z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default SplitScreenIcon;
